import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'react-bootstrap';
import format from 'date-fns/format';

const CreditsOrders = (props) => {
  return (
    <Table responsive>
      <thead>
        <tr>
          <th>Tipo di operazione</th>
          <th>Data</th>
          <th>Quantità</th>
          <th>Note</th>
        </tr>
      </thead>
      <tbody>
        {props.orders.map((order) => {
          let metadata;
          let note;
          try {
            metadata = JSON.parse(order.note);
            if (metadata.canvasId) {
              note = (
                <a data-navigo href={`/canvas/${metadata.canvasId}`}>
                  {metadata.projectTypeName}
                </a>
              );
            } else {
              let segments = [];
              if (metadata.servizioName) {
                segments.push(metadata.servizioName);
              }
              if (metadata.feature) {
                segments.push(metadata.feature);
              }
              note = segments.join(' - ');
            }
          } catch (e) {
            note = order.note;
          }

          const totalCredits =
            order.paidCreditsAmount + order.freeCreditsAmount;

          return (
            <tr key={order.objectId}>
              <td>{totalCredits > 0 ? 'Acquisto' : 'Utilizzo'}</td>
              <td>{format(new Date(order.createdAt), 'dd/MM/yyyy HH:mm')}</td>
              <td>{order.paidCreditsAmount || order.freeCreditsAmount}</td>
              <td>{note}</td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};

CreditsOrders.propTypes = {
  orders: PropTypes.array,
};

export default CreditsOrders;
